export default __webpack_public_path__ + "static/media/instagram.75e70345.svg";